import { render, staticRenderFns } from "./LogoutModule.vue?vue&type=template&id=b04a99b0&scoped=true&"
import script from "./LogoutModule.vue?vue&type=script&lang=js&"
export * from "./LogoutModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04a99b0",
  null
  
)

export default component.exports